import { useParams, useSearchParams } from 'react-router-dom';

import { TaskDetail } from '@/components/tasks/task-detail';
import { TaskGroupings } from '@/components/tasks/TaskGroupings';
import { TaskPanelSkeleton } from '@/components/ui/skeletons/MatterSkeleton';

import useMatterSelection from '../../hooks/useMatterSelection';

interface TaskPanelProps {
  onOpenCreateTask: () => void;
  /** Ref that will be populated with TaskDetail's internal handleStatusChange handler */
  onStatusChangeRef?: React.MutableRefObject<((status: { id: string; canonical_status: string }) => void) | null>;
  /** Search term for task filtering (managed by parent) */
  searchTerm?: string;
  onSearchTermChange?: (value: string) => void;
}

export const TaskPanel: React.FC<TaskPanelProps> = ({ onOpenCreateTask, onStatusChangeRef, searchTerm, onSearchTermChange }) => {
  const { matter_id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const { selectedMatterLoading } = useMatterSelection();

  // Get task_id from query parameters instead of route parameters
  const task_id = searchParams.get('task_id');

  const handleBackToTasks = () => {
    // Remove task_id from query parameters instead of navigating to a different route
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.delete('task_id');
    setSearchParams(newSearchParams);
  };

  if (selectedMatterLoading) {
    return <TaskPanelSkeleton />;
  }

  return (
    <div className="flex flex-col h-full">
      <div className="overflow-y-auto flex-grow scrollbar-thin">
        {task_id ? (
          <TaskDetail
            taskId={task_id}
            matterId={matter_id}
            onClose={handleBackToTasks}
            isModal={false}
            hideStatusControls
            onStatusChangeRef={onStatusChangeRef}
          />
        ) : (
          <TaskGroupings onOpenCreateTask={onOpenCreateTask} searchTerm={searchTerm} onSearchTermChange={onSearchTermChange} />
        )}
      </div>
    </div>
  );
};

export default TaskPanel;
